<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'kaikille'
};
</script>

<style scoped></style>
